"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optimizedPhoneToPhone = exports.isOptimizedPhoneValue = exports.isOptimizedPhone = exports.isPhoneTypesValue = exports.isCountryCodeValue = void 0;
const libphonenumber_js_1 = require("libphonenumber-js");
const primitives_1 = require("./primitives");
const arrays_1 = require("./arrays");
const typing_1 = require("./typing");
const types_1 = require("@smartsuite/types");
const phone_number_1 = require("../../formatters/phone-number");
const objects_1 = require("./objects");
/**
 * Check if value is CountryCode.
 *
 * @param value
 */
const isCountryCodeValue = (value) => {
    return (0, primitives_1.isStringValue)(value) && (0, libphonenumber_js_1.isSupportedCountry)(value);
};
exports.isCountryCodeValue = isCountryCodeValue;
/**
 * Check if value is PhoneTypes.
 *
 * @param value
 */
const isPhoneTypesValue = (value) => {
    return ((0, primitives_1.isNumberValue)(value) && Object.values(types_1.PhoneTypes).includes(value));
};
exports.isPhoneTypesValue = isPhoneTypesValue;
const isOptimizedPhone = (value) => {
    return (0, objects_1.isValidObjectValue)(value, {
        country: (0, typing_1.Optional)(exports.isCountryCodeValue),
        no: (0, typing_1.Optional)((0, typing_1.Union)(primitives_1.isStringValue, primitives_1.isNumberValue)),
        ext: (0, typing_1.Optional)(primitives_1.isStringValue),
        type: (0, typing_1.Optional)(exports.isPhoneTypesValue),
        root: (0, typing_1.Optional)(primitives_1.isStringValue),
    });
};
exports.isOptimizedPhone = isOptimizedPhone;
/**
 * Check if value is PhoneItem.
 *
 * @param value
 */
const isOptimizedPhoneValue = (value) => {
    return (0, arrays_1.isArrayOfValidObjectsValue)(value, {
        country: (0, typing_1.Optional)(exports.isCountryCodeValue),
        no: (0, typing_1.Optional)((0, typing_1.Union)(primitives_1.isStringValue, primitives_1.isNumberValue)),
        ext: (0, typing_1.Optional)(primitives_1.isStringValue),
        type: (0, typing_1.Optional)(exports.isPhoneTypesValue),
        root: (0, typing_1.Optional)(primitives_1.isStringValue),
    });
};
exports.isOptimizedPhoneValue = isOptimizedPhoneValue;
/**
 * Convert OptimizedPhoneItem to PhoneItem.
 *
 * @param phone
 */
const optimizedPhoneToPhone = (phone) => {
    var _a, _b, _c, _d, _e, _f;
    const sysRoot = (_a = phone === null || phone === void 0 ? void 0 : phone.root) !== null && _a !== void 0 ? _a : (0, phone_number_1.onlyStringNumbers)((_b = phone === null || phone === void 0 ? void 0 : phone.no) !== null && _b !== void 0 ? _b : "");
    return {
        phone_country: (_c = phone === null || phone === void 0 ? void 0 : phone.country) !== null && _c !== void 0 ? _c : types_1.DEFAULT_COUNTRY,
        phone_number: (_d = phone === null || phone === void 0 ? void 0 : phone.no) !== null && _d !== void 0 ? _d : "",
        phone_extension: (_e = phone === null || phone === void 0 ? void 0 : phone.ext) !== null && _e !== void 0 ? _e : "",
        phone_type: (_f = phone === null || phone === void 0 ? void 0 : phone.type) !== null && _f !== void 0 ? _f : types_1.PhoneTypes.mobile,
        sys_title: generatePhoneTitle(phone),
        sys_root: sysRoot,
    };
};
exports.optimizedPhoneToPhone = optimizedPhoneToPhone;
const generatePhoneTitle = (phone) => {
    var _a, _b;
    const number = (_a = phone.no) !== null && _a !== void 0 ? _a : "";
    const extension = (_b = phone.ext) !== null && _b !== void 0 ? _b : "";
    if (extension) {
        return number + " " + extension;
    }
    return number;
};
